import { render, staticRenderFns } from "./identity.vue?vue&type=template&id=e7d7b0b4&scoped=true&"
import script from "./identity.vue?vue&type=script&lang=js&"
export * from "./identity.vue?vue&type=script&lang=js&"
import style0 from "./identity.vue?vue&type=style&index=0&id=e7d7b0b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d7b0b4",
  null
  
)

export default component.exports